import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import CheckIcon from "@mui/icons-material/Check";
import { MdSearch } from "react-icons/md";
// import OldTaskDetails from "./OldTaskDetails";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker.css";
// import OldTaskDetailsHardware from "./OldTaskDetailsHardware";
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { fetchWorkEntries, fetchWorkEntriesProjectTracking } from "../../../../../store/slices/workentriesSlice";
import { fetchDescriptionTasks, fetchDescriptionTasksProjectTracking } from "../../../../../store/slices/DescriptionTask";
import { fetchHardwareDescriptions, fetchHardwareProjectTracking } from "../../../../../store/slices/hardwareDescriptionSlice";
import { fetchEmployees } from "../../../../../store/slices/employeeAdminSlice";
import { fetchAllProjects } from "../../../../../store/slices/projectsSlice";
import { updateProjectDueDate } from "../../../../../store/slices/projectDueDateSlice";
import ShowAssignTableManager from "./ShowAssignTableManager";
import AdminLoader from "../../../../../components/common/loader/AdminLoader";
import FileUploadSales from "../../../SalesOperations/SaleOperation/ResponseReceived/FileUploadSales";
import DateConversion from "../../../../../utils/DateConversion";
import AssignOPAction from "./AssignOPAction";
import { fetchGroups } from "../../../../../store/slices/groupSlice";
import { getMyTrainings } from "../../../../../store/slices/MyTraining/myTrainings";
import {
    consolidateTrainingExpenseRowsForDisplay,
    isTrainingExpenseEntry,
    resolveTrainingAssigneeId,
    trainingMatchesEmployeeProject,
    unwrapTrainings,
} from "../../../../../utils/trainingOtherExpenseSync";

const ManagerAssignSelf = ({ assignedProjectsManager, isViewOnly = false }) => {
    const { formatDateByCountry, getDatePlaceholder, getDateFormat } = DateConversion();
    const dispatch = useDispatch();
    const { employees } = useSelector((state) => state.employees);
    const { projects } = useSelector((state) => state.projects);
    const { entries } = useSelector((state) => state.workentries);
    const { tasks } = useSelector((state) => state.descriptionTasks);
    const { group: groups } = useSelector((state) => state.group);
    const { mytrainings } = useSelector((state) => state.myTrainings);
    const [currentProject, setCurrentProject] = useState(null);
    const [showAttach, setShowAttach] = useState(false);
    const { projectTrackingWorkEntries } = useSelector(
        (state) => state.workentries
    );
    const { hardwareProjectTracking } = useSelector(
        (state) => state.hardwareDescription
    );
    const { descriptionProjectTracking } = useSelector(
        (state) => state.descriptionTasks
    );

    const [isLoading, setIsLoading] = useState(false);
    const loggedUserEmail = localStorage.getItem("email");
    const [showAction,] = useState({ 0: "tasktable" });


    useEffect(() => {
        dispatch(fetchWorkEntriesProjectTracking());
        dispatch(fetchDescriptionTasksProjectTracking());
        dispatch(fetchHardwareProjectTracking());
        dispatch(fetchDescriptionTasks());
        dispatch(fetchWorkEntries());
        dispatch(fetchEmployees());
        dispatch(fetchHardwareDescriptions());
        dispatch(fetchAllProjects());
        dispatch(fetchGroups());
        dispatch(getMyTrainings());
    }, [dispatch]);

    const groupNameById = React.useMemo(() => {
        const map = new Map();
        (groups || []).forEach((g) => {
            const id = g?._id || g?.id;
            const name = g?.newGroupName || g?.groupname || g?.groupName || g?.name || "";
            if (id && name) map.set(String(id), name);
        });
        return map;
    }, [groups]);

    const getDisplayGroupName = React.useCallback(
        (projectRow) => {
            const groupId = projectRow?.groupid?._id || projectRow?.groupid;
            if (groupId && groupNameById.has(String(groupId))) {
                return groupNameById.get(String(groupId));
            }
            return projectRow?.AssignedGroup || "";
        },
        [groupNameById]
    );

    const refreshAssign = () => {
        dispatch(fetchDescriptionTasks());
        dispatch(fetchWorkEntries());
        dispatch(fetchEmployees());
        dispatch(fetchHardwareDescriptions());
        dispatch(fetchAllProjects());
        dispatch(fetchWorkEntriesProjectTracking());
        dispatch(fetchDescriptionTasksProjectTracking());
        dispatch(fetchHardwareProjectTracking());
        dispatch(getMyTrainings());
    }

    const [, setAssignedProjectsManager] = useState([]);

    useEffect(() => {
        const filtered = projects.filter(
            (proj) =>
                Array.isArray(proj.Assignedperson) &&
                proj.Assignedperson.some(
                    (person) => person.managerstatus === "project assigned"
                )
        );
        const managerProjects = filtered.filter((proj) =>
            proj.Assignedperson?.some(
                (person) =>
                    person.email?.toLowerCase() === loggedUserEmail.toLowerCase()
            )
        );
        setAssignedProjectsManager(managerProjects);
    }, [projects, loggedUserEmail]);

    const [sortedProjects, setSortedProjects] = useState([]);

    useEffect(() => {
        setSortedProjects(assignedProjectsManager);
    }, [assignedProjectsManager]);

    const itemsPerPage = 10; // or any number of rows you want per page
    const [currentPage, setCurrentPage] = useState(1);

    const [searchQuery, setSearchQuery] = useState("");

    const handleSearchInputChange = (e) => {
        const query = e.target.value;
        setSearchQuery(query);
        setCurrentPage(1);
        filterLeadReports(query)
    };

    const totalItems = sortedProjects.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const startIdx = (currentPage - 1) * itemsPerPage;
    const endIdx = startIdx + itemsPerPage;
    const paginatedProjects = sortedProjects.slice(startIdx, endIdx);


    const filterLeadReports = (query) => {
        const lowerCaseQuery = query.toLowerCase().trim();

        const filtered = assignedProjectsManager.filter((LeadReport) =>
            getDisplayGroupName(LeadReport).toLowerCase().includes(lowerCaseQuery) ||
            Object.entries(LeadReport).some(([key, value]) => {
                // Skip these keys
                if (
                    key === "Assignedperson" ||
                    key === "TypeService" ||
                    key === "SalesPersonName" ||
                    key === "SalesPersonEmail" ||
                    key === "ResourceType" ||
                    key === "QuotedValue" ||
                    key === "ProjectManagerStatus" ||
                    key === "ProjectManagerAction" ||
                    key === "createdAt" ||
                    key === "updatedAt" ||
                    key === "PrimaryResources"
                )
                    return false;

                if (value === null || value === undefined) return false;
                if (key === "DateRequested" || key === "ProjectDueDate") {
                    const formattedDate = formatDateByCountry(value);  // ← change here
                    return formattedDate.toLowerCase().includes(lowerCaseQuery);
                }

                // Handle all other fields
                const formattedValue = value.toString().trim().toLowerCase();
                return formattedValue.includes(lowerCaseQuery);
            })
        );

        setSortedProjects(filtered);
    };

    const sortAlphabetically = (targetToSort, order) => {
        const key = `${targetToSort}-${order}`;
        let sorted = [...sortedProjects]; // Always sort from the filtered dataset

        const compareStrings = (a, b) => {
            const valA = (a || "").toString().toLowerCase();
            const valB = (b || "").toString().toLowerCase();
            return valA.localeCompare(valB);
        };
        // Helper function for date comparison
        const compareDates = (a, b) => {
            const dateA = a ? new Date(a) : null;
            const dateB = b ? new Date(b) : null;

            if (!dateA && !dateB) return 0;
            if (!dateA) return 1;
            if (!dateB) return -1;

            return dateA - dateB;
        };

        switch (key) {
            case "AssignedGroup-az":
                sorted.sort((a, b) => compareStrings(getDisplayGroupName(a), getDisplayGroupName(b)));
                break;
            case "AssignedGroup-za":
                sorted.sort((a, b) => compareStrings(getDisplayGroupName(b), getDisplayGroupName(a)));
                break;
            case "ProjectName-az":
                sorted.sort((a, b) => compareStrings(a.ProjectName, b.ProjectName));
                break;
            case "ProjectName-za":
                sorted.sort((a, b) => compareStrings(b.ProjectName, a.ProjectName));
                break;
            case "DateRequested-az":
                sorted.sort((a, b) => compareDates(a.DateRequested, b.DateRequested));
                break;
            case "DateRequested-za":
                sorted.sort((a, b) => compareDates(b.DateRequested, a.DateRequested));
                break;
            case "ProjectDueDate-az":
                sorted.sort((a, b) => compareDates(a.ProjectDueDate, b.ProjectDueDate));
                break;
            case "ProjectDueDate-za":
                sorted.sort((a, b) => compareDates(b.ProjectDueDate, a.ProjectDueDate));
                break;
            default:
                sorted = [...sortedProjects];
                break;
        }
        setSortedProjects(sorted);
        setCurrentPage(1); // Reset to first page after sorting
    };

    const [openRowId, setOpenRowId] = useState(null);

    const [selectedProjectId, setSelectedProjectId] = useState(null);

    const handleSelectProject = (projectId) => {
        // If selecting a new project, load its entries
        if (projectId !== selectedProjectId) {
            setSelectedProjectId(projectId);
        }
    };

    const handleSelectProjectDescription = (projectId) => {
        if (projectId !== selectedProjectId) {
            setSelectedProjectId(projectId);
        }
    };

    const handleSelectProjectHardwareParts = (
        projectId) => {
        // If selecting a new project, load its entries
        if (projectId !== selectedProjectId) {
            setSelectedProjectId(projectId);
        }
    };

    const [employeesAssignedData, setEmployeesAssignedData] = useState([]);

    const prevRef = useRef();

    useEffect(() => {
        if (JSON.stringify(prevRef.current) !== JSON.stringify(employeesAssignedData)) {
            prevRef.current = employeesAssignedData;
        }
    }, [employeesAssignedData]);

    useEffect(() => {
        if (assignedProjectsManager.length > 0 && employees.length > 0) {
            const tasks = projectTrackingWorkEntries || [];
            const descriptions = descriptionProjectTracking || [];
            const hardwareParts = hardwareProjectTracking || [];

            const normKey = (value) =>
                String(value || "").trim().replace(/\s+/g, " ").toLowerCase();

            const isHardwareTrainingCostDescription = (entry) =>
                isTrainingExpenseEntry(entry) ||
                normKey(entry?.description).startsWith("training cost");

            const getTrainingCostRowsForHardwareAssignment = (project, emp, existingDescriptions = []) => {
                if (!String(project?.TypeService || "").toLowerCase().includes("hardware")) return [];
                const assigneeId = String(emp?._id || "").trim();
                const assigneeEmail = String(emp?.EmpEmail || emp?.email || "").trim().toLowerCase();
                if (!assigneeId && !assigneeEmail) return [];

                const alreadyHasTrainingCost = existingDescriptions.some((entry) => {
                    const owner = String(entry?.taskownerid ?? "").trim();
                    return (!owner || owner === assigneeId) && isHardwareTrainingCostDescription(entry);
                });
                if (alreadyHasTrainingCost) return [];

                const leadLike = project?.lead || project?.Lead || {};
                const projectMeta = {
                    assigneeEmail,
                    rowId: project?._id,
                    projectIds: [
                        project?._id,
                        project?.id,
                        project?.projectid,
                        project?.projectId,
                        project?.ProjectID,
                        leadLike?._id,
                        leadLike?.id,
                    ].filter(Boolean),
                    quotationIds: [
                        project?.quotationId,
                        project?.quotationID,
                        project?.quotationid,
                        project?.QuotationId,
                        project?.QuotationID,
                        leadLike?.quotationId,
                        leadLike?.quotationID,
                        leadLike?.quotationid,
                        leadLike?.QuotationId,
                        leadLike?.QuotationID,
                    ].filter(Boolean),
                    projectNames: [
                        project?.ProjectName,
                        project?.projectname,
                        leadLike?.ProjectName,
                        leadLike?.projectname,
                    ].filter(Boolean),
                    leadIds: [
                        project?.leadid,
                        project?.leadId,
                        project?.LeadId,
                        project?.LeadID,
                        leadLike?.leadid,
                        leadLike?.leadId,
                        leadLike?.LeadId,
                        leadLike?.LeadID,
                    ].filter(Boolean),
                };

                const rowProjectNames = projectMeta.projectNames.map(normKey);
                const matchedTrainings = unwrapTrainings(mytrainings).filter((training) => {
                    if (assigneeId && trainingMatchesEmployeeProject(training, assigneeId, projectMeta)) {
                        return true;
                    }

                    const assignedRaw = training?.assignedto ?? training?.assignedTo;
                    const assignedId = resolveTrainingAssigneeId(assignedRaw);
                    const assignedEmail =
                        typeof assignedRaw === "string" && assignedRaw.includes("@")
                            ? assignedRaw.trim().toLowerCase()
                            : String(training?.assignedToEmail || "").trim().toLowerCase();
                    const assigneeMatches =
                        (assigneeId && assignedId && String(assignedId) === assigneeId) ||
                        (assigneeEmail && assignedEmail && assignedEmail === assigneeEmail);
                    if (!assigneeMatches) return false;

                    const trainingProjectName = normKey(training?.projectname);
                    return Boolean(trainingProjectName && rowProjectNames.includes(trainingProjectName));
                });

                const total = matchedTrainings.reduce((sum, training) => {
                    const amount = Number(
                        String(training?.trainingcost ?? training?.trainingCost ?? 0).replace(/,/g, "")
                    );
                    return sum + (Number.isFinite(amount) ? amount : 0);
                }, 0);

                if (total <= 0) return [];

                const notes = Array.from(
                    new Set(
                        matchedTrainings
                            .map((training) => String(training?.trainingname || training?.trainingName || "").trim())
                            .filter(Boolean)
                    )
                ).join("; ");

                return [{
                    _id: `my-assignment-training-cost-${project?._id || "project"}-${assigneeId || assigneeEmail}`,
                    projectid: project?._id,
                    taskownerid: assigneeId,
                    description: "Training Cost",
                    value: total,
                    notes,
                    sourceType: "training",
                    sourceTrainingId: `my-assignment-training-total-${project?._id || "project"}-${assigneeId || assigneeEmail}`,
                    readOnly: true,
                    _prmSyntheticTrainingExpense: true,
                }];
            };

            const result = assignedProjectsManager.map((project) => {
                const empData = project.Assignedperson.map((person) => {
                    const emp = employees.find((employee) => {
                        const isProjectManager =
                            employee.customRoles?.includes("project manager");
                        // return (
                        //     employee.EmpEmail === person.email &&
                        //     project.TypeService === employee.servicetype &&
                        //     (isProjectManager
                        //         ? true // ✅ skip status validation
                        //         : person.projecttracktaskStatus !== undefined &&
                        //         person.projecttracktaskStatus !== null)
                        // );
                        return (
                            employee.EmpEmail === person.email &&
                            project.TypeService === employee.servicetype &&
                            !employee.customRoles?.includes("operations") && // ⛔ exclude operations
                            (isProjectManager
                                ? true
                                : person.projecttracktaskStatus !== undefined &&
                                person.projecttracktaskStatus !== null)
                        );

                    });

                    if (emp) {
                        // 🔹 If employee is only "project manager", override Assignedperson.name & fullName
                        let assignedPersonData = { ...person };
                        let fullName = `${emp.EmpFirstName} ${emp.EmpLastName}`;
                        let isSelf = false;

                        if (
                            Array.isArray(emp.customRoles) &&
                            emp.customRoles.length === 1 &&
                            emp.customRoles[0] === "project manager"
                        ) {
                            assignedPersonData = { ...person, name: "Self" };
                            fullName = "Self";
                            isSelf = true; // ✅ track Self case
                        }

                        const baseDescriptionList = descriptions.filter(
                            (entry) =>
                                entry.taskownerid === emp._id &&
                                entry.projectid === project?._id &&
                                (emp.customRoles?.includes("project manager")
                                    ? true
                                    : entry?.isProjectAssigned === true) &&
                                (emp.customRoles?.includes("project manager")
                                    ? true // ✅ skip taskstatus check for project managers
                                    : isSelf
                                        ? entry.taskstatus === "submit"
                                        : true)
                        );

                        const trainingCostRows = getTrainingCostRowsForHardwareAssignment(
                            project,
                            emp,
                            baseDescriptionList
                        );

                        return {
                            projectid: project?._id,
                            Assignedperson: assignedPersonData,
                            fullName,
                            email: emp.EmpEmail,
                            _id: emp._id,
                            EmpGroups: emp?.EmpGroups || [],
                            customRole: emp.customRoles,
                            TypeService: project?.TypeService,

                            workEntries: tasks.filter(
                                (entry) =>
                                    entry.taskownerid === emp._id &&
                                    entry.projectid === project?._id &&
                                    (emp.customRoles?.includes("project manager")
                                        ? true // ✅ skip isProjectAssigned check for project managers
                                        : entry?.isProjectAssigned === true) &&
                                    (emp.customRoles?.includes("project manager")
                                        ? true // ✅ skip taskStatus check for project managers
                                        : isSelf
                                            ? entry.taskStatus === "submit"
                                            : true)
                            ),

                            DescriptionList: consolidateTrainingExpenseRowsForDisplay([
                                ...baseDescriptionList,
                                ...trainingCostRows,
                            ]),

                            HardwareParts: hardwareParts.filter(
                                (entry) =>
                                    entry.taskownerid === emp._id &&
                                    entry.projectid === project?._id &&
                                    (emp.customRoles?.includes("project manager")
                                        ? true // ✅ skip validation for project managers
                                        : entry?.isProjectAssigned === true) &&
                                    (emp.customRoles?.includes("project manager")
                                        ? true // ✅ skip taskStatus check for project managers
                                        : isSelf
                                            ? entry.taskStatus === "submit"
                                            : true)
                            ),
                        };
                    }

                    return null;
                }).filter(Boolean);

                return {
                    projectId: project._id,
                    ProjectName: project?.ProjectName,
                    // Assignedperson: project.Assignedperson,
                    data: empData,
                };
            });
            setEmployeesAssignedData(result);
        }
    }, [
        assignedProjectsManager,
        employees,
        projectTrackingWorkEntries,
        descriptionProjectTracking,
        hardwareProjectTracking,
        mytrainings,
    ]);

    const [rowId, setRowId] = useState(null)
    const [rowTypeService, setRowTypeService] = useState(null)
    const ProjectAssignref = useRef(null);

    useEffect(() => {
        if ((rowId)) {
            const scrollToPosition = ProjectAssignref.current.scrollWidth;
            ProjectAssignref.current.scrollTo({
                left: scrollToPosition,
                behavior: 'smooth'
            });
        }
    }, [rowId]);

    const handleDueDateChange = async (date, projectId) => {
        if (isViewOnly) return;
        if (!date || !projectId) return;
        setIsLoading(true);
        try {
            await dispatch(updateProjectDueDate({ id: projectId, ProjectDueDate: date }));
        } catch (error) {
            console.error("Failed to update due date:", error);
        } finally {
            setIsLoading(false);
            dispatch(fetchAllProjects())
        }
    };


    useEffect(() => {
        console.log("myassignment employeesAssignedData", employeesAssignedData)
    }, [employeesAssignedData])
    const [showListState, setShowListState] = useState("tasktable")
    const [clickedPersonId, setClickedPersonId] = useState(null);
    console.log("myassignment showListState", showListState)
    console.log("myassignment clickedPersonId", clickedPersonId)
    return (
        <>
            <div className="w-[100%] bg-white">
                {isLoading ? <AdminLoader isLoading={isLoading} /> : <></>}
                <>
                    <div className="flex justify-between items-center p-2  bg-white rounded-t ">
                        <div className=" font-semibold">
                            Project Assigned
                        </div>

                        <div className="flex gap-2 py-1 px-1 align-middle items-center bg-[#e0e7ff] rounded-full">
                            <MdSearch className=" w-5 h-5 text-gray-500" />
                            <input
                                type="text"
                                value={searchQuery}
                                onChange={handleSearchInputChange}
                                placeholder="Search"
                                className="bg-[#e0e7ff] outline-none w-[80%]"
                            />
                        </div>
                    </div>
                    <div ref={ProjectAssignref} className="w-full max-h-[85vh]  overflow-auto  justify-center ">
                        <div className="w-full sticky top-0 z-[1299]">
                            <div className="flex  bg-[#E8E8E8] text-black text-xs  text-center">
                                <div className={`${rowId ? "" : "w-[80%]"} flex font-semibold`}>
                                    <div className="h-12 w-12 border text-xs flex justify-center align-middle items-center">
                                        Sr. No
                                    </div>
                                    <div className={`h-12 ${rowId ? "w-28 flex-shrink-0" : "w-[22%]"} relative border break-all whitespace-normal  p-2 truncate flex justify-center items-center align-middle text-xs line-clamp-2 `}>
                                        <p className="w-[75%] break-words whitespace-normal text-start pl-4">Group</p>
                                        <div className="w-[25%] flex flex-col -mt-1">
                                            <ArrowDropUp
                                                className="cursor-pointer"
                                                sx={{ fontSize: "20px" }}
                                                onClick={() => sortAlphabetically("AssignedGroup", "az")}
                                            />
                                            <ArrowDropDown
                                                className="cursor-pointer -mt-2"
                                                sx={{ fontSize: "20px" }}
                                                onClick={() => sortAlphabetically("AssignedGroup", "za")}
                                            />
                                        </div>
                                    </div>
                                    <div className={`h-12 ${rowId ? "w-28 flex-shrink-0" : "w-[22%]"} relative border break-all whitespace-normal p-2 truncate flex justify-center items-center align-middle text-xs line-clamp-2`}>
                                        <p className="w-[75%] break-words whitespace-normal text-start">Project</p>
                                        <div className="w-[25%] flex flex-col -mt-1">
                                            <ArrowDropUp
                                                className="cursor-pointer"
                                                sx={{ fontSize: "20px" }}
                                                onClick={() => sortAlphabetically("ProjectName", "az")}
                                            />
                                            <ArrowDropDown
                                                className="cursor-pointer -mt-2"
                                                sx={{ fontSize: "20px" }}
                                                onClick={() => sortAlphabetically("ProjectName", "za")}
                                            />
                                        </div>
                                    </div>
                                    <div className={`h-12 ${rowId ? "w-28 flex-shrink-0" : "w-[20%]"} relative border break-all whitespace-normal  p-2 truncate flex justify-center items-center align-middle text-xs line-clamp-2 `}>
                                        <p className="w-[75%] break-words whitespace-normal text-start pl-2">Date Requested</p>
                                        <div className="w-[25%] flex flex-col -mt-1 pl-2">
                                            <ArrowDropUp
                                                className="cursor-pointer"
                                                sx={{ fontSize: "20px" }}
                                                onClick={() => sortAlphabetically("DateRequested", "az")}
                                            />
                                            <ArrowDropDown
                                                className="cursor-pointer -mt-2"
                                                sx={{ fontSize: "20px" }}
                                                onClick={() => sortAlphabetically("DateRequested", "za")}
                                            />
                                        </div>
                                    </div>
                                    <div className={`h-12 ${rowId ? "w-28 flex-shrink-0" : "w-[20%]"} relative border break-all whitespace-normal  p-2 truncate flex justify-center items-center align-middle text-xs line-clamp-2 `}>
                                        <p className="w-[75%] break-words whitespace-normal text-start pl-2">Due Date</p>
                                        <div className="w-[25%] flex flex-col -mt-1">
                                            <ArrowDropUp
                                                className="cursor-pointer"
                                                sx={{ fontSize: "20px" }}
                                                onClick={() => sortAlphabetically("ProjectDueDate", "az")}
                                            />
                                            <ArrowDropDown
                                                className="cursor-pointer -mt-2"
                                                sx={{ fontSize: "20px" }}
                                                onClick={() => sortAlphabetically("ProjectDueDate", "za")}
                                            />
                                        </div>
                                    </div>
                                    <div className={`h-12 ${rowId ? "w-28 flex-shrink-0" : "w-[20%]"} flex justify-center items-center border p-2 break-words text-wrap`}>
                                        Attachment
                                    </div>
                                </div>
                                {rowId ? (
                                    <div className="h-12 font-semibold flex bg-[#E8E8E8] text-black  ">
                                        <div className="w-28 p-1 border break-words text-wrap flex justify-start items-center">
                                            Select Employee
                                        </div>
                                        <div className="w-[30rem] h-full border break-words text-wrap flex flex-col justify-center items-center">
                                            <div className="w-full h-[50%] border break-words text-wrap flex justify-center items-center" >
                                                Tasks Details
                                            </div>
                                            <div className="w-full h-[50%] border break-words text-wrap flex ">
                                                <div
                                                    onClick={() => setShowListState("tasktable")}
                                                    className={`w-[50%] ${showListState === "tasktable" ? "bg-blue-500 text-white" : "text-black"} p-1 cursor-pointer flex justify-center items-center`}>
                                                    {Array.isArray(rowTypeService)
                                                        ? (rowTypeService.some((service) =>
                                                            service?.toLowerCase().includes("hardware")
                                                        )
                                                            ? "Part List"
                                                            : "Effort Expenses")
                                                        : rowTypeService?.toLowerCase().includes("hardware")
                                                            ? "Part List"
                                                            : "Effort Expenses"}
                                                </div>
                                                <div
                                                    onClick={() => setShowListState("otherexpenses")}
                                                    className={` w-[50%] ${showListState === "otherexpenses" ? "bg-blue-500 text-white" : "text-black"} p-1 cursor-pointer flex justify-center items-center`}>
                                                    Other Expenses
                                                </div>
                                            </div>
                                        </div>
                                        <div className="w-28  border p-2 break-words text-wrap flex justify-center items-center">
                                            Action
                                        </div>
                                    </div>
                                ) : (
                                    <div className="font-semibold flex justify-center items-center bg-[#E8E8E8] text-black w-[16%]">
                                        <div className="h-12 w-full p-2 break-words text-wrap">
                                            Input Details
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="w-full ">
                            {paginatedProjects.map((row, index) => {
                                const matchedRowEntries = projectTrackingWorkEntries.filter(
                                    (entry) => entry.projectid === row._id
                                );
                                const matchedRowDesctiption =
                                    descriptionProjectTracking.filter(
                                        (entry) => entry.projectid === row._id
                                    );

                                const matchedRowHardwareEntries =
                                    hardwareProjectTracking.filter(
                                        (entry) => entry.projectid === row._id
                                    );

                                return (
                                    <div
                                        className={`flex text-xs ${row.isRead === false ? "font-bold" : " "}  cursor-pointer group`}
                                        key={index}
                                    >
                                        <div className={`${rowId ? "" : "w-[80%]"} flex`}>
                                            <div onClick={() => {
                                                const isSameRow = rowId === row._id;
                                                setRowId(isSameRow ? null : row?._id);
                                                setRowTypeService(isSameRow ? null : row?.TypeService);
                                                handleSelectProject(row._id, matchedRowEntries);
                                                handleSelectProjectDescription(
                                                    row._id,
                                                    matchedRowDesctiption
                                                );
                                                handleSelectProjectHardwareParts(
                                                    row._id,
                                                    matchedRowHardwareEntries
                                                );
                                                handleSelectProject(row._id, matchedRowEntries);
                                                handleSelectProjectDescription(
                                                    row._id,
                                                    matchedRowDesctiption
                                                );
                                                handleSelectProjectHardwareParts(
                                                    row._id,
                                                    matchedRowHardwareEntries
                                                );
                                                setOpenRowId(
                                                    row._id === openRowId ? null : row._id
                                                );
                                            }}
                                                className="w-12 border-b text-xs flex justify-center align-middle items-center group-hover:bg-gray-100 ">
                                                {startIdx + index + 1}
                                            </div>
                                            <div onClick={() => {
                                                const isSameRow = rowId === row._id;
                                                setRowId(isSameRow ? null : row?._id);
                                                setRowTypeService(isSameRow ? null : row?.TypeService);
                                                handleSelectProject(row._id, matchedRowEntries);
                                                handleSelectProjectDescription(
                                                    row._id,
                                                    matchedRowDesctiption
                                                );
                                                handleSelectProjectHardwareParts(
                                                    row._id,
                                                    matchedRowHardwareEntries
                                                );
                                                handleSelectProject(row._id, matchedRowEntries);
                                                handleSelectProjectDescription(
                                                    row._id,
                                                    matchedRowDesctiption
                                                );
                                                handleSelectProjectHardwareParts(
                                                    row._id,
                                                    matchedRowHardwareEntries
                                                );
                                                setOpenRowId(
                                                    row._id === openRowId ? null : row._id
                                                );
                                            }}
                                                className={`${rowId ? "w-28 flex-shrink-0" : "w-[22%]"} border-b break-words whitespace-normal  p-2 truncate flex justify-start items-center align-middle text-xs line-clamp-2 group-hover:bg-gray-100 `}>
                                                <span className="pl-4"> {getDisplayGroupName(row)}</span>
                                            </div>
                                            <div onClick={() => {
                                                const isSameRow = rowId === row._id;
                                                setRowId(isSameRow ? null : row?._id);
                                                setRowTypeService(isSameRow ? null : row?.TypeService);
                                                handleSelectProject(row._id, matchedRowEntries);
                                                handleSelectProjectDescription(
                                                    row._id,
                                                    matchedRowDesctiption
                                                );
                                                handleSelectProjectHardwareParts(
                                                    row._id,
                                                    matchedRowHardwareEntries
                                                );
                                                handleSelectProject(row._id, matchedRowEntries);
                                                handleSelectProjectDescription(
                                                    row._id,
                                                    matchedRowDesctiption
                                                );
                                                handleSelectProjectHardwareParts(
                                                    row._id,
                                                    matchedRowHardwareEntries
                                                );
                                                setOpenRowId(
                                                    row._id === openRowId ? null : row._id
                                                );
                                            }}
                                                className={`${rowId ? "w-28 flex-shrink-0" : "w-[22%]"} border-b flex justify-start align-middle items-center text-left p-2 group-hover:bg-gray-100 break-words whitespace-normal overflow-hidden text-ellipsis line-clamp-2 leading-snug text-xs`}>
                                                <span className=""> {row.ProjectName}</span>
                                            </div>
                                            <div onClick={() => {
                                                const isSameRow = rowId === row._id;
                                                setRowId(isSameRow ? null : row?._id);
                                                setRowTypeService(isSameRow ? null : row?.TypeService);
                                                handleSelectProject(row._id, matchedRowEntries);
                                                handleSelectProjectDescription(
                                                    row._id,
                                                    matchedRowDesctiption
                                                );
                                                handleSelectProjectHardwareParts(
                                                    row._id,
                                                    matchedRowHardwareEntries
                                                );
                                                handleSelectProject(row._id, matchedRowEntries);
                                                handleSelectProjectDescription(
                                                    row._id,
                                                    matchedRowDesctiption
                                                );
                                                handleSelectProjectHardwareParts(
                                                    row._id,
                                                    matchedRowHardwareEntries
                                                );
                                                setOpenRowId(
                                                    row._id === openRowId ? null : row._id
                                                );
                                            }}
                                                className={`${rowId ? "w-28 flex-shrink-0" : "w-[20%]"} border-b flex justify-center align-middle group-hover:bg-gray-100  items-center p-2 break-words text-wrap`}>
                                                <span className="pr-2">  {row.DateRequested &&
                                                    !isNaN(new Date(row.DateRequested))
                                                    ? formatDateByCountry(row.DateRequested)
                                                    : ""}
                                                </span>

                                            </div>
                                            <div
                                                className={`${rowId ? "w-28 flex-shrink-0" : "w-[20%]"} border-b flex justify-center group-hover:bg-gray-100  align-middle items-center p-2 break-words text-wrap`}>
                                                <DatePicker
                                                    selected={
                                                        row.ProjectDueDate
                                                            ? new Date(row.ProjectDueDate)
                                                            : null
                                                    }
                                                    onChange={(date) => handleDueDateChange(date, row._id)}
                                                    dateFormat={getDateFormat()}
                                                    className={`ProjectDueDateSelector w-full h-full text-center outline-none border border-gray-300 p-2 rounded-md ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : "bg-white"}`}
                                                    placeholderText={getDatePlaceholder()}
                                                    popperClassName="z-[1500]"
                                                    minDate={new Date()}
                                                    disabled={isViewOnly}
                                                />
                                            </div>
                                            <div className={`${rowId ? "w-28 flex-shrink-0" : "w-[20%]"} border-b p-2 text-center group-hover:bg-gray-100  flex justify-center align-middle items-center break-words text-wrap`}>
                                                <AttachFileIcon
                                                    className="rotate-12 cursor-pointer"
                                                    onClick={() => {
                                                        setCurrentProject(row);
                                                        setShowAttach(true);
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div
                                            className={`flex flex-col  ${rowId ? "w-full" : "w-[20%]"} group-hover:bg-gray-100 border-b`}
                                        >
                                            {rowId === row?._id ? (
                                                <>
                                                    {employeesAssignedData
                                                        .filter(
                                                            (project) =>
                                                                project.projectId === row._id &&
                                                                project.data.length > 0
                                                        )
                                                        .flatMap((project) => project.data)
                                                        .map((emp, index) => (
                                                            <div
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                }}
                                                                key={emp._id}
                                                                className="border-gray-300 text-center flex "
                                                            >
                                                                <div
                                                                    className="w-28 p-1 text-center break-words text-wrap items-center justify-center">
                                                                    <div className="w-full flex">
                                                                        <div className="w-[70%]  flex justify-start items-center break-all whitespace-normal">
                                                                            {emp.fullName}
                                                                        </div>
                                                                        <div className="w-[30%] flex justify-center items-center ">
                                                                            {emp.Assignedperson?.projecttracktaskStatus === "pending" &&
                                                                                emp.Assignedperson?.operationaction !== "reject" && (
                                                                                    <span
                                                                                        title="Pending"
                                                                                        className="text-orange-500 text-xl font-bold px-1 ml-2 rounded"
                                                                                    >
                                                                                        !
                                                                                    </span>
                                                                                )}
                                                                            {emp.Assignedperson
                                                                                ?.operationaction === "reject" && (
                                                                                    <span
                                                                                        title="Rejected"
                                                                                        className="text-red-800 text-xl font-bold px-1 ml-2 rounded"
                                                                                    >
                                                                                        !
                                                                                    </span>
                                                                                )}
                                                                            {emp.Assignedperson
                                                                                ?.projecttracktaskStatus === "submit" && (
                                                                                    <span
                                                                                        title="Submitted"
                                                                                        className="text-green-600 text-xl font-bold  px-1 ml-2 rounded"
                                                                                    >
                                                                                        <CheckIcon className=" text-green-600" />
                                                                                    </span>
                                                                                )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                    }}
                                                                    className="w-[30rem]"
                                                                >
                                                                    <ShowAssignTableManager
                                                                        refreshAssign={refreshAssign}
                                                                        index={index}
                                                                        showAction={showAction}
                                                                        matchedRowEntries={matchedRowEntries}
                                                                        row={row}
                                                                        emp={emp}
                                                                        setIsLoading={setIsLoading}
                                                                        employees={employees}
                                                                        matchedOldRowDesctiption={tasks}
                                                                        matchedOldRowEntries={entries}
                                                                        showListState={showListState}
                                                                        clickedPersonId={clickedPersonId}
                                                                        setClickedPersonId={setClickedPersonId}
                                                                        isViewOnly={isViewOnly}
                                                                    />
                                                                </div>
                                                                <div
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                    }}
                                                                    className="w-28 flex justify-center p-2 break-words text-wrap items-center"
                                                                >
                                                                    <AssignOPAction
                                                                        index={index}
                                                                        row={row}
                                                                        emp={emp}
                                                                        setIsLoading={setIsLoading}
                                                                        isViewOnly={isViewOnly}
                                                                    />
                                                                </div>
                                                            </div>
                                                        ))}
                                                    {/* <div
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                        }}
                                                        className="">
                                                        {row.TypeService?.toLowerCase().includes("hardware") ? (
                                                            <>
                                                                <OldTaskDetailsHardware
                                                                    setIsLoading={setIsLoading}
                                                                    isLoading={isLoading}
                                                                    index={index}
                                                                    row={row}
                                                                    matchedRowEntries={matchedRowEntries}
                                                                    matchedRowDesctiption={matchedRowDesctiption}
                                                                    employees={employees}
                                                                    matchedRowHardwareEntries={
                                                                        matchedRowHardwareEntries
                                                                    }
                                                                    matchedOldRowDesctiption={tasks}
                                                                    matchedOldRowEntries={entries}
                                                                    setSelectedEmpInDrop={setSelectedEmpInDrop}
                                                                    selectedEmpInDrop={selectedEmpInDrop}
                                                                    setEmployeeWithTasks={setEmployeeWithTasks}
                                                                    refreshAssign={refreshAssign}
                                                                    employeeWithTasks={employeeWithTasks}
                                                                    filteredCancelEmployee={filteredCancelEmployee}
                                                                />
                                                            </>
                                                        ) : (
                                                            <>

                                                                <OldTaskDetails
                                                                    setIsLoading={setIsLoading}
                                                                    isLoading={isLoading}
                                                                    index={index}
                                                                    row={row}
                                                                    matchedRowEntries={matchedRowEntries}
                                                                    matchedRowDesctiption={matchedRowDesctiption}
                                                                    employees={employees}
                                                                    matchedRowHardwareEntries={
                                                                        matchedRowHardwareEntries
                                                                    }
                                                                    matchedOldRowDesctiption={tasks}
                                                                    matchedOldRowEntries={entries}
                                                                    setSelectedEmpInDrop={setSelectedEmpInDrop}
                                                                    selectedEmpInDrop={selectedEmpInDrop}
                                                                    setEmployeeWithTasks={setEmployeeWithTasks}
                                                                    employeeWithTasks={employeeWithTasks}
                                                                    filteredCancelEmployee={filteredCancelEmployee}
                                                                    refreshAssign={refreshAssign}
                                                                />
                                                            </>
                                                        )}

                                                    </div> */}


                                                </>
                                            ) : (
                                                rowId ? (
                                                    <div onClick={
                                                        () => {
                                                            const isSameRow = rowId === row._id;
                                                            setRowId(isSameRow ? null : row?._id);
                                                            setRowTypeService(isSameRow ? null : row?.TypeService);
                                                            handleSelectProject(row._id, matchedRowEntries);
                                                            handleSelectProjectDescription(
                                                                row._id,
                                                                matchedRowDesctiption
                                                            );
                                                            handleSelectProjectHardwareParts(
                                                                row._id,
                                                                matchedRowHardwareEntries
                                                            );
                                                            handleSelectProject(row._id, matchedRowEntries);
                                                            handleSelectProjectDescription(
                                                                row._id,
                                                                matchedRowDesctiption
                                                            );
                                                            handleSelectProjectHardwareParts(
                                                                row._id,
                                                                matchedRowHardwareEntries
                                                            );
                                                            setOpenRowId(
                                                                row._id === openRowId ? null : row._id
                                                            );
                                                        }}
                                                        className="flex justify-center items-center align-middle">
                                                        <div className="w-28"></div>
                                                        <div className="w-[30rem] pt-4 flex justify-center align-middle items-center">Multiple</div>
                                                        <div className="w-28"></div>
                                                    </div>
                                                ) : (
                                                    <div
                                                        onClick={
                                                            () => {
                                                                const isSameRow = rowId === row._id;
                                                                setRowId(isSameRow ? null : row?._id);
                                                                setRowTypeService(isSameRow ? null : row?.TypeService);
                                                                handleSelectProject(row._id, matchedRowEntries);
                                                                handleSelectProjectDescription(
                                                                    row._id,
                                                                    matchedRowDesctiption
                                                                );
                                                                handleSelectProjectHardwareParts(
                                                                    row._id,
                                                                    matchedRowHardwareEntries
                                                                );
                                                                handleSelectProject(row._id, matchedRowEntries);
                                                                handleSelectProjectDescription(
                                                                    row._id,
                                                                    matchedRowDesctiption
                                                                );
                                                                handleSelectProjectHardwareParts(
                                                                    row._id,
                                                                    matchedRowHardwareEntries
                                                                );
                                                                setOpenRowId(
                                                                    row._id === openRowId ? null : row._id
                                                                );
                                                            }}
                                                        className="w-full h-full flex justify-center items-center pt-2 group-hover:bg-gray-100">
                                                        Multiple
                                                    </div>
                                                )

                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                            {paginatedProjects.length === 0 && (
                                <div className="noDataAvailable p-2">No Result Found</div>
                            )}
                        </div>
                    </div>
                    <div
                        className={`pagination flex justify-between  text-xs items-center bg-white mt-3 pb-2 pl-2 rounded-md ${paginatedProjects.length > 0 ? "p-1" : ""
                            } `}
                    >
                        <div>
                            {totalItems > 0 ? (
                                <>
                                    Showing {startIdx + 1} to {Math.min(endIdx, totalItems)} of{" "}
                                    {totalItems} Entries
                                </>
                            ) : (
                                <>
                                    {paginatedProjects.length > 0 && (
                                        <>Showing {paginatedProjects.length} Entries</>
                                    )}
                                </>
                            )}
                        </div>

                        {totalPages > 1 && (
                            <div className="flex">
                                <button
                                    onClick={() => setCurrentPage(1)}
                                    className="px-2 py-2 mx-1 border rounded"
                                    disabled={currentPage === 1}
                                    title="First Page"
                                >
                                    <KeyboardDoubleArrowLeftIcon className="w-5 h-5" />
                                </button>
                                <button
                                    onClick={() =>
                                        setCurrentPage((prev) => Math.max(prev - 1, 1))
                                    }
                                    className="px-2 py-2 mx-2 border rounded"
                                    disabled={currentPage === 1}
                                >
                                    <ChevronRightIcon className="w-5 h-5 rotate-180" />
                                </button>

                                {Array.from({ length: 3 }, (_, index) => {
                                    const pageNumber = currentPage - 1 + index;
                                    if (pageNumber >= 1 && pageNumber <= totalPages) {
                                        return (
                                            <button
                                                key={pageNumber}
                                                onClick={() => setCurrentPage(pageNumber)}
                                                className={`px-4 py-2 mx-2 border rounded ${currentPage === pageNumber
                                                    ? "bg-gray-300"
                                                    : ""
                                                    }`}
                                            >
                                                {pageNumber}
                                            </button>
                                        );
                                    }
                                    return null;
                                })}

                                <button
                                    onClick={() =>
                                        setCurrentPage((prev) =>
                                            Math.min(prev + 1, totalPages)
                                        )
                                    }
                                    className="px-2 py-2 mx-2 border rounded"
                                    disabled={currentPage === totalPages}
                                >
                                    <ChevronRightIcon className="w-5 h-5" />
                                </button>

                                <button
                                    onClick={() => setCurrentPage(totalPages)}
                                    className="px-2 py-2 mx-1 border rounded"
                                    disabled={currentPage === totalPages}
                                    title="Last Page"
                                >
                                    <KeyboardDoubleArrowRightIcon className="w-5 h-5" />
                                </button>
                            </div>
                        )}
                    </div>



                    {showAttach && (
                        <FileUploadSales
                            currentProject={currentProject}
                            setShowAttach={setShowAttach}
                            employees={employees}
                            isViewOnly={isViewOnly}
                        />
                    )
                    }
                </>
            </div >
        </>
    )
}

export default ManagerAssignSelf